export const isLocal = ({ VITE_ENV }) => VITE_ENV === 'local'
export const isStaging = ({ VITE_ENV }) => VITE_ENV === 'staging'
export const isProduction = ({ VITE_ENV }) => VITE_ENV === 'production'
export const isDeployment = (env) => isStaging(env) || isProduction(env)
